/** PM Keyboard Navigation — j/k to switch threads, Escape to blur. */

(function() {
  var navigating = false;
  var navIndex = -1;

  function isTyping() {
    var el = document.activeElement;
    if (!el) return false;
    var tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable;
  }

  function getThreads() {
    return Array.from(document.querySelectorAll('#threads_left .pm_thread'));
  }

  function syncIndex() {
    var threads = getThreads();
    var active = document.querySelector('#threads_left .pm_thread.active');
    navIndex = active ? threads.indexOf(active) : -1;
    return threads;
  }

  document.addEventListener('keydown', function(e) {
    if (!document.querySelector('.privateMessages')) return;

    // Escape: blur input first, then close thread on second press
    if (e.key === 'Escape' && !e.altKey && !e.ctrlKey && !e.metaKey) {
      if (isTyping()) {
        document.activeElement.blur();
        e.preventDefault();
        return;
      }
      var activeThread = document.querySelector('#threads_left .pm_thread.active');
      if (activeThread && window.close_thread) {
        e.preventDefault();
        window.close_thread();
        navIndex = -1;
      }
      return;
    }

    // j/k: navigate between threads (only when not typing)
    if (e.key !== 'j' && e.key !== 'k') return;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    if (isTyping()) return;
    if (navigating) return;

    e.preventDefault();

    var threads = getThreads();
    if (!threads.length) return;

    // Sync from DOM if we haven't navigated yet or index is stale
    if (navIndex < 0 || navIndex >= threads.length) {
      syncIndex();
    }

    var nextIndex;
    if (e.key === 'k') {
      nextIndex = Math.max(0, navIndex - 1);
    } else {
      nextIndex = Math.min(threads.length - 1, navIndex + 1);
    }

    if (nextIndex === navIndex) return;

    var nextThread = threads[nextIndex];
    var threadId = nextThread.id.replace('thread_', '');

    console.log('[kb-nav] ' + e.key + ': ' + navIndex + ' → ' + nextIndex);

    navIndex = nextIndex;
    navigating = true;

    if (window.htm5_history_supported) {
      history.pushState({ thread_id: threadId }, null, '/app/messages?thread_id=' + threadId);
      window.view_thread(threadId, true);

      // view_thread has a scroll guard that preserves scroll position for ~300ms.
      // Wait for it to finish, then scroll only if thread is out of view.
      setTimeout(function() {
        var container = document.getElementById('threads_left');
        if (container && nextThread) {
          var cRect = container.getBoundingClientRect();
          var tRect = nextThread.getBoundingClientRect();
          if (tRect.bottom > cRect.bottom || tRect.top < cRect.top) {
            container.scrollBy({ top: tRect.top - cRect.top - (container.clientHeight / 2) + (nextThread.offsetHeight / 2), left: 0, behavior: 'smooth' });
          }
        }
        navigating = false;
      }, 350);
    } else {
      window.location.href = '/app/messages?thread_id=' + threadId;
    }
  });

  // Reset tracked index when user clicks a thread manually
  document.addEventListener('click', function(e) {
    var threadEl = e.target.closest?.('#threads_left .pm_thread');
    if (threadEl) {
      var threads = getThreads();
      navIndex = threads.indexOf(threadEl);
    }
  });
})();
